module.exports = __webpack_public_path__ + "static/media/flags_CHL.58897ab3.svg";